import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./css/portfolio.css";
import SewerIMage1 from "../assets/images/NewImage1.jpeg";
import SewerIMage2 from "../assets/images/NewPortfolio3.jpeg";
import Manhole1 from "../assets/images/NewPortfolio.jpeg";
import Manhole2 from "../assets/images/manholeInspection.jpg";
import Manhole3 from "../assets/images/manholeInspection3.jpg";
import DrainageKeepup from "../assets/images/NewPortfolio2.jpeg";
import DrainageKeepup2 from "../assets/images/DrainageKeepup2.jpg";
import DrainageKeepup3 from "../assets/images/DrainageKeepup3.jpg";
import DrainageKeepup4 from "../assets/images/DrainageKeepup4.jpg";

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [isAnimating, setIsAnimating] = useState(false);

  const portfolioItems = [
    {
      id: 1,
      categories: ["Sewer Line Cleaning & Maintenance"],
      image: SewerIMage1,
      description: "Seatech Infra offers end-to-end solutions for sewer line cleaning and upkeep, ensuring urban environments remain hygienic. Its expert teams and advanced technologies are deployed to manage complex sanitation requirements with efficiency and precision.",
    },
    {
      id: 2,
      categories: ["Desliting Operations & Drainage Upkeep"],
      image: DrainageKeepup,
      description: "Seatech Infra is adept at desilting operations, essential for maintaining free-flowing drainage systems. Its services also extend to the lining, repair, and overall upkeep of drainage networks to support municipal resilience.",
    },
    {
      id: 3,
      categories: ["Sewer Line Cleaning & Maintenance"],
      image: SewerIMage2,
      description: "Seatech Infra offers end-to-end solutions for sewer line cleaning and upkeep, ensuring urban environments remain hygienic. Its expert teams and advanced technologies are deployed to manage complex sanitation requirements with efficiency and precision.",
    },
    {
      id: 4,
      categories: [
        "Manhole Inspection & Management",
        "Sewer Line Cleaning & Maintenance",
      ],
      image: Manhole1,
      description: "Seatech Infra is adept at desilting operations, essential for maintaining free-flowing drainage systems. Its services also extend to the lining, repair, and overall upkeep of drainage networks to support municipal resilience.",
    },
    {
      id: 5,
      categories: ["Manhole Inspection & Management"],
      image: Manhole3,
      description: "Seatech Infra is adept at desilting operations, essential for maintaining free-flowing drainage systems. Its services also extend to the lining, repair, and overall upkeep of drainage networks to support municipal resilience.",
    },
    {
      id: 6,
      categories: [
        "Manhole Inspection & Management",
        "Sewer Line Cleaning & Maintenance",
      ],
      image: Manhole2,
      description: "Seatech Infra offers end-to-end solutions for sewer line cleaning and upkeep, ensuring urban environments remain hygienic. Its expert teams and advanced technologies are deployed to manage complex sanitation requirements with efficiency and precision.",
    },
  ];

  const categories = [
    "All",
    "Manhole Inspection & Management",
    "Sewer Line Cleaning & Maintenance",
    "Desliting Operations & Drainage Upkeep",
  ];

  const getFilteredItems = (filter) => {
    return filter === "All"
      ? portfolioItems
      : portfolioItems.filter((item) => item.categories.includes(filter));
  };

  const handleFilterChange = (newFilter) => {
    if (newFilter === activeFilter || isAnimating) return;

    setIsAnimating(true);
    setActiveFilter(newFilter);

    // Set a timeout to reset the animation state after the transition completes
    setTimeout(() => {
      setIsAnimating(false);
    }, 500); // Match this duration with your animation duration
  };

  const filteredItems = getFilteredItems(activeFilter);

  return (
    <div id="portfolio" className="portfolio-container">
      <div className="portfolio-header">

        <h1>PORTFOLIO</h1>
        <div className="divider-white"></div>
      </div>
      {/* Navigation Tabs */}
      <div className="portfolio-nav-container">
        <div className="portfolio-nav-tabs">
          {categories.map((category, index) => (
            <React.Fragment key={category}>
              <button
                onClick={() => handleFilterChange(category)}
                disabled={isAnimating}
                className={`portfolio-nav-button ${
                  activeFilter === category ? "portfolio-nav-button-active" : ""
                } ${isAnimating ? "portfolio-nav-button-disabled" : ""}`}
              >
                {category}
              </button>
              {index < categories.length - 1 && (
                <div className="portfolio-slash">/</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Portfolio Grid */}
      <div className="portfolio-grid-container">
        <motion.div className="portfolio-grid" layout>
          <AnimatePresence>
            {filteredItems.map((item) => (
              <motion.div
                key={item.id}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="portfolio-item group"
              >
                <div className="portfolio-item-image-container">
                  <img
                    src={item.image}
                    alt={item.description}
                    className="portfolio-item-image"
                  />
                </div>

                {/* Overlay */}
                <div className="portfolio-item-overlay">
                  <div className="portfolio-item-overlay-content">
                    <h3 className="portfolio-item-description">
                      {item.categories.join(" • ")}
                    </h3>
                    <p className="portfolio-item-categories">{item.description}</p>
                  </div>
                </div>


                {/* Category Badges */}
                {/* <div className="portfolio-item-badges">
                  {item.categories.map((category, index) => (
                    <span
                      key={index}
                      className={`portfolio-item-badge ${getCategoryClass(
                        category
                      )}`}
                    >
                      {category.length > 10
                        ? `${category.substring(0, 10)}...`
                        : category}
                    </span>
                  ))}
                </div> */}
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

// Helper functions remain the same
// const getImageId = (category) => {
//   const imageMap = {
//     "Sewer Line Cleaning & Maintenance": "1416879595882-3373a3480c25",
//     Repairing: "1581833971358-2c8b550f87b3",
//     "Manhole Inspection & Management": "1586023492125-27b2c045efd7",
//   };
//   return imageMap[category] || "1416879595882-3373a3480c25";
// };

const getCategoryClass = (category) => {
  const classMap = {
    "Sewer Line Cleaning & Maintenance": "badge-wood",
    Repairing: "badge-repair",
    "Manhole Inspection & Management": "badge-indoor",
  };
  return classMap[category] || "badge-default";
};

export default Portfolio;
